/**
 * The 24 hours after a case is closed as suspicious (LFPIORPI art. 18 fr. VI, S-32): the cases waiting
 * for the decision "an aviso was filed" / "none was filed". Visible only to the designated compliance
 * officer and super_admins; the server answers 403 to everyone else.
 */
import type { AxiosInstance } from 'axios';
import authService from './auth.service';

export type AvisoDecision = 'filed' | 'not_filed';

export interface SuspicionClock {
  id: string;
  source_kind: 'monitoring_alert' | 'sanctions_match';
  source_id: number;
  client_id: string | null;
  client_name: string | null;
  started_at: string;
  /** Who closed the case as suspicious. */
  started_by: string;
  started_by_name: string | null;
  hours_open: number;
  due_hours: number;
  decision: AvisoDecision | null;
  aviso_reference: string | null;
  reason: string | null;
  decided_at: string | null;
  decided_by_name: string | null;
}

export interface DecisionInput {
  decision: AvisoDecision;
  aviso_reference: string | null;
  reason: string | null;
  mfa_code: string;
}

const BASE = '/api/v1/compliance/suspicion-avisos';

class SuspicionAvisosService {
  private get api(): AxiosInstance {
    return authService.getApi();
  }

  async list(pendingOnly: boolean): Promise<SuspicionClock[]> {
    return (await this.api.get<SuspicionClock[]>(BASE, { params: { pending_only: pendingOnly } })).data;
  }

  async decide(id: string, body: DecisionInput): Promise<void> {
    await this.api.post(`${BASE}/${id}/decision`, body);
  }
}

export default new SuspicionAvisosService();
